import { TimeFormat, USER_FORMAT } from '@agilox/ui-common';
import { DatePipe } from '@angular/common';
import { inject, Inject, Pipe, PipeTransform } from '@angular/core';

const FormatMap = {
	[TimeFormat.TWELVE_HOUR]: 'hh:mm\u00A0a',
	[TimeFormat.TWENTY_FOUR_HOUR]: 'HH:mm',
};

@Pipe({
	name: 'customTime',
})
export class CustomTimePipe implements PipeTransform {
	@Inject(USER_FORMAT) private userFormat = inject(USER_FORMAT);
	private datePipe = inject(DatePipe);

	transform(value: number | string | undefined | null, timezone?: string, seconds?: boolean): any {
		let format = FormatMap[this.userFormat().time];
		if (seconds) {
			format = format.replace('mm', 'mm:ss');
		}

		return this.datePipe.transform(value, format, timezone)?.toLowerCase();
	}
}
